module.exports = __webpack_public_path__ + "static/media/cropIcon_Flax.1458b199.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Editor/components/CropPageView/Catalog/Images/cropIcon_Flax.png
// module id = 730
// module chunks = 0